import ConsentModel from './consent'
import {setCookie} from '../util/storage'
import {getCurrentPageChannel} from '../util/channel'

export default class ConsentModModel extends ConsentModel {
  public async save (origin: string): Promise<void> {
    const channel = getCurrentPageChannel()

    const response = await this.send(origin, channel)
    const {euconsent, uuid} = await response.json()

    this.updateStorage(euconsent, uuid)

    setCookie(ConsentModel.cookieName, euconsent, this.getCookieExpireDays(this.consented))
    setCookie('uuid', uuid, 100 * 365)

    this.load()
    this.emit('update')
  }
}
